/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SuggestionsRouteImport } from './routes/suggestions'
import { Route as SkillTreeConceptRouteImport } from './routes/skill-tree-concept'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as LabsRouteImport } from './routes/labs'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CoursesRouteImport } from './routes/courses'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LabsIndexRouteImport } from './routes/labs.index'
import { Route as WelcomeStep3RouteImport } from './routes/welcome.step-3'
import { Route as WelcomeStep2RouteImport } from './routes/welcome.step-2'
import { Route as WelcomeStep1RouteImport } from './routes/welcome.step-1'
import { Route as OnboardingStep2RouteImport } from './routes/onboarding.step-2'
import { Route as OnboardingStep1RouteImport } from './routes/onboarding.step-1'
import { Route as LabsIdRouteImport } from './routes/labs.$id'
import { Route as CoursesIdRouteImport } from './routes/courses.$id'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as CoursesIdLabsRouteImport } from './routes/courses.$id.labs'

const SuggestionsRoute = SuggestionsRouteImport.update({
  id: '/suggestions',
  path: '/suggestions',
  getParentRoute: () => rootRouteImport,
} as any)
const SkillTreeConceptRoute = SkillTreeConceptRouteImport.update({
  id: '/skill-tree-concept',
  path: '/skill-tree-concept',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const LabsRoute = LabsRouteImport.update({
  id: '/labs',
  path: '/labs',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const CoursesRoute = CoursesRouteImport.update({
  id: '/courses',
  path: '/courses',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutRoute = CheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LabsIndexRoute = LabsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LabsRoute,
} as any)
const WelcomeStep3Route = WelcomeStep3RouteImport.update({
  id: '/welcome/step-3',
  path: '/welcome/step-3',
  getParentRoute: () => rootRouteImport,
} as any)
const WelcomeStep2Route = WelcomeStep2RouteImport.update({
  id: '/welcome/step-2',
  path: '/welcome/step-2',
  getParentRoute: () => rootRouteImport,
} as any)
const WelcomeStep1Route = WelcomeStep1RouteImport.update({
  id: '/welcome/step-1',
  path: '/welcome/step-1',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingStep2Route = OnboardingStep2RouteImport.update({
  id: '/onboarding/step-2',
  path: '/onboarding/step-2',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingStep1Route = OnboardingStep1RouteImport.update({
  id: '/onboarding/step-1',
  path: '/onboarding/step-1',
  getParentRoute: () => rootRouteImport,
} as any)
const LabsIdRoute = LabsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => LabsRoute,
} as any)
const CoursesIdRoute = CoursesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => CoursesRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const CoursesIdLabsRoute = CoursesIdLabsRouteImport.update({
  id: '/labs',
  path: '/labs',
  getParentRoute: () => CoursesIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/checkout': typeof CheckoutRoute
  '/contact': typeof ContactRoute
  '/courses': typeof CoursesRouteWithChildren
  '/dashboard': typeof DashboardRoute
  '/labs': typeof LabsRouteWithChildren
  '/pricing': typeof PricingRoute
  '/signin': typeof SigninRoute
  '/skill-tree-concept': typeof SkillTreeConceptRoute
  '/suggestions': typeof SuggestionsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/courses/$id': typeof CoursesIdRouteWithChildren
  '/labs/$id': typeof LabsIdRoute
  '/onboarding/step-1': typeof OnboardingStep1Route
  '/onboarding/step-2': typeof OnboardingStep2Route
  '/welcome/step-1': typeof WelcomeStep1Route
  '/welcome/step-2': typeof WelcomeStep2Route
  '/welcome/step-3': typeof WelcomeStep3Route
  '/labs/': typeof LabsIndexRoute
  '/courses/$id/labs': typeof CoursesIdLabsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/checkout': typeof CheckoutRoute
  '/contact': typeof ContactRoute
  '/courses': typeof CoursesRouteWithChildren
  '/dashboard': typeof DashboardRoute
  '/pricing': typeof PricingRoute
  '/signin': typeof SigninRoute
  '/skill-tree-concept': typeof SkillTreeConceptRoute
  '/suggestions': typeof SuggestionsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/courses/$id': typeof CoursesIdRouteWithChildren
  '/labs/$id': typeof LabsIdRoute
  '/onboarding/step-1': typeof OnboardingStep1Route
  '/onboarding/step-2': typeof OnboardingStep2Route
  '/welcome/step-1': typeof WelcomeStep1Route
  '/welcome/step-2': typeof WelcomeStep2Route
  '/welcome/step-3': typeof WelcomeStep3Route
  '/labs': typeof LabsIndexRoute
  '/courses/$id/labs': typeof CoursesIdLabsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/checkout': typeof CheckoutRoute
  '/contact': typeof ContactRoute
  '/courses': typeof CoursesRouteWithChildren
  '/dashboard': typeof DashboardRoute
  '/labs': typeof LabsRouteWithChildren
  '/pricing': typeof PricingRoute
  '/signin': typeof SigninRoute
  '/skill-tree-concept': typeof SkillTreeConceptRoute
  '/suggestions': typeof SuggestionsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/courses/$id': typeof CoursesIdRouteWithChildren
  '/labs/$id': typeof LabsIdRoute
  '/onboarding/step-1': typeof OnboardingStep1Route
  '/onboarding/step-2': typeof OnboardingStep2Route
  '/welcome/step-1': typeof WelcomeStep1Route
  '/welcome/step-2': typeof WelcomeStep2Route
  '/welcome/step-3': typeof WelcomeStep3Route
  '/labs/': typeof LabsIndexRoute
  '/courses/$id/labs': typeof CoursesIdLabsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/checkout'
    | '/contact'
    | '/courses'
    | '/dashboard'
    | '/labs'
    | '/pricing'
    | '/signin'
    | '/skill-tree-concept'
    | '/suggestions'
    | '/auth/callback'
    | '/courses/$id'
    | '/labs/$id'
    | '/onboarding/step-1'
    | '/onboarding/step-2'
    | '/welcome/step-1'
    | '/welcome/step-2'
    | '/welcome/step-3'
    | '/labs/'
    | '/courses/$id/labs'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/checkout'
    | '/contact'
    | '/courses'
    | '/dashboard'
    | '/pricing'
    | '/signin'
    | '/skill-tree-concept'
    | '/suggestions'
    | '/auth/callback'
    | '/courses/$id'
    | '/labs/$id'
    | '/onboarding/step-1'
    | '/onboarding/step-2'
    | '/welcome/step-1'
    | '/welcome/step-2'
    | '/welcome/step-3'
    | '/labs'
    | '/courses/$id/labs'
  id:
    | '__root__'
    | '/'
    | '/checkout'
    | '/contact'
    | '/courses'
    | '/dashboard'
    | '/labs'
    | '/pricing'
    | '/signin'
    | '/skill-tree-concept'
    | '/suggestions'
    | '/auth/callback'
    | '/courses/$id'
    | '/labs/$id'
    | '/onboarding/step-1'
    | '/onboarding/step-2'
    | '/welcome/step-1'
    | '/welcome/step-2'
    | '/welcome/step-3'
    | '/labs/'
    | '/courses/$id/labs'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CheckoutRoute: typeof CheckoutRoute
  ContactRoute: typeof ContactRoute
  CoursesRoute: typeof CoursesRouteWithChildren
  DashboardRoute: typeof DashboardRoute
  LabsRoute: typeof LabsRouteWithChildren
  PricingRoute: typeof PricingRoute
  SigninRoute: typeof SigninRoute
  SkillTreeConceptRoute: typeof SkillTreeConceptRoute
  SuggestionsRoute: typeof SuggestionsRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  OnboardingStep1Route: typeof OnboardingStep1Route
  OnboardingStep2Route: typeof OnboardingStep2Route
  WelcomeStep1Route: typeof WelcomeStep1Route
  WelcomeStep2Route: typeof WelcomeStep2Route
  WelcomeStep3Route: typeof WelcomeStep3Route
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/suggestions': {
      id: '/suggestions'
      path: '/suggestions'
      fullPath: '/suggestions'
      preLoaderRoute: typeof SuggestionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/skill-tree-concept': {
      id: '/skill-tree-concept'
      path: '/skill-tree-concept'
      fullPath: '/skill-tree-concept'
      preLoaderRoute: typeof SkillTreeConceptRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/labs': {
      id: '/labs'
      path: '/labs'
      fullPath: '/labs'
      preLoaderRoute: typeof LabsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/courses': {
      id: '/courses'
      path: '/courses'
      fullPath: '/courses'
      preLoaderRoute: typeof CoursesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout': {
      id: '/checkout'
      path: '/checkout'
      fullPath: '/checkout'
      preLoaderRoute: typeof CheckoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/labs/': {
      id: '/labs/'
      path: '/'
      fullPath: '/labs/'
      preLoaderRoute: typeof LabsIndexRouteImport
      parentRoute: typeof LabsRoute
    }
    '/welcome/step-3': {
      id: '/welcome/step-3'
      path: '/welcome/step-3'
      fullPath: '/welcome/step-3'
      preLoaderRoute: typeof WelcomeStep3RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/welcome/step-2': {
      id: '/welcome/step-2'
      path: '/welcome/step-2'
      fullPath: '/welcome/step-2'
      preLoaderRoute: typeof WelcomeStep2RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/welcome/step-1': {
      id: '/welcome/step-1'
      path: '/welcome/step-1'
      fullPath: '/welcome/step-1'
      preLoaderRoute: typeof WelcomeStep1RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/step-2': {
      id: '/onboarding/step-2'
      path: '/onboarding/step-2'
      fullPath: '/onboarding/step-2'
      preLoaderRoute: typeof OnboardingStep2RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/step-1': {
      id: '/onboarding/step-1'
      path: '/onboarding/step-1'
      fullPath: '/onboarding/step-1'
      preLoaderRoute: typeof OnboardingStep1RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/labs/$id': {
      id: '/labs/$id'
      path: '/$id'
      fullPath: '/labs/$id'
      preLoaderRoute: typeof LabsIdRouteImport
      parentRoute: typeof LabsRoute
    }
    '/courses/$id': {
      id: '/courses/$id'
      path: '/$id'
      fullPath: '/courses/$id'
      preLoaderRoute: typeof CoursesIdRouteImport
      parentRoute: typeof CoursesRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/courses/$id/labs': {
      id: '/courses/$id/labs'
      path: '/labs'
      fullPath: '/courses/$id/labs'
      preLoaderRoute: typeof CoursesIdLabsRouteImport
      parentRoute: typeof CoursesIdRoute
    }
  }
}

interface CoursesIdRouteChildren {
  CoursesIdLabsRoute: typeof CoursesIdLabsRoute
}

const CoursesIdRouteChildren: CoursesIdRouteChildren = {
  CoursesIdLabsRoute: CoursesIdLabsRoute,
}

const CoursesIdRouteWithChildren = CoursesIdRoute._addFileChildren(
  CoursesIdRouteChildren,
)

interface CoursesRouteChildren {
  CoursesIdRoute: typeof CoursesIdRouteWithChildren
}

const CoursesRouteChildren: CoursesRouteChildren = {
  CoursesIdRoute: CoursesIdRouteWithChildren,
}

const CoursesRouteWithChildren =
  CoursesRoute._addFileChildren(CoursesRouteChildren)

interface LabsRouteChildren {
  LabsIdRoute: typeof LabsIdRoute
  LabsIndexRoute: typeof LabsIndexRoute
}

const LabsRouteChildren: LabsRouteChildren = {
  LabsIdRoute: LabsIdRoute,
  LabsIndexRoute: LabsIndexRoute,
}

const LabsRouteWithChildren = LabsRoute._addFileChildren(LabsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CheckoutRoute: CheckoutRoute,
  ContactRoute: ContactRoute,
  CoursesRoute: CoursesRouteWithChildren,
  DashboardRoute: DashboardRoute,
  LabsRoute: LabsRouteWithChildren,
  PricingRoute: PricingRoute,
  SigninRoute: SigninRoute,
  SkillTreeConceptRoute: SkillTreeConceptRoute,
  SuggestionsRoute: SuggestionsRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  OnboardingStep1Route: OnboardingStep1Route,
  OnboardingStep2Route: OnboardingStep2Route,
  WelcomeStep1Route: WelcomeStep1Route,
  WelcomeStep2Route: WelcomeStep2Route,
  WelcomeStep3Route: WelcomeStep3Route,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
